import { PositionedContainer } from '../../../../components'
import styled from 'styled-components'

const PositionedContainerStyled = styled(PositionedContainer)`
  bottom: var(--icon-examples-bottom);
  right: var(--icon-examples-right);
`

export default PositionedContainerStyled
